import React, { useState } from 'react';
import { SearchRewardProvider } from './searchRewardProvider';

import './rewardAdmin.scss'
import { Link } from 'react-router-dom';

export function AdminRewardProvider() {
    const [refresh, setRefresh] = useState(0);

    return (
        <section className="wrapper_reward_admin padd">
            <div className="mb-4 divtop">
                <div className="box_ttl_opt no_reverse mb-0">
                    <div>
                        <h2 className="mb-0 text fnt_medium">Proveedores</h2>
                        <h6 className="mb-0 text-muted">Operaciones</h6>
                    </div>
                    <div className="box_actions">
                        <Link className="btn primary" to={"/details-rewardProvider/0"}><i className="fas fa-plus"></i> Agregar Proveedor</Link>
                    </div>
                </div>
            </div>
            <div>
                <SearchRewardProvider refresh={refresh} />
            </div>

        </section>
    );
}